// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1e31ceb","453":"300f961b","455":"877ba523","977":"33b26864"}[chunkId] + ".chunk.js";
};